// extracted by mini-css-extract-plugin
module.exports = {"title":"Land_title__2vacj","landBox":"Land_landBox__1bZNv"};